// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"219f087e","488":"e3fe3630","977":"c119fbc5"}[chunkId] + ".chunk.js";
};